import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./responsive.css";
import reportWebVitals from "./reportWebVitals";
import { store } from "./data/store";
import { Provider } from "react-redux";
import TagManager from "react-gtm-module";

TagManager.initialize({ gtmId: "GTM-WW4SB5TP" });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
